import { I18n } from '@calendly/i18n'
import moment from 'moment-timezone'
import { useSelector } from 'react-redux'

import { dateNotationSelector } from 'selectors/current_user'
import { userDateRangeFormat } from 'services/time_format'

export const useDateRangeLabel = (period, startDate = null, endDate = null) => {
  const dateNotation = useSelector(dateNotationSelector)

  const buildRangeLabel = () => {
    const from = moment(startDate)
    const to = moment(endDate)
    const [fromStr, toStr] = userDateRangeFormat(
      from, to, dateNotation, 'date_small', 'date_small_with_year',
    )
    return `${fromStr} – ${toStr}`
  }

  // i18n-tasks-use t('publisher.meetings.filter_modal.dates.this_week')
  // i18n-tasks-use t('publisher.meetings.filter_modal.dates.this_month')
  // i18n-tasks-use t('publisher.meetings.filter_modal.dates.today')

  switch (period) {
    case 'today':
    case 'this_week':
    case 'this_month':
    case 'this_year':
      return I18n.t(`publisher.meetings.filter_modal.dates.${period}`)
    case 'fixed':
      return buildRangeLabel()
    default:
      return I18n.t('publisher.meetings.filter_modal.dates.all')
  }
}
